export const colors = {
  info: '#6367EF',
  infoBg: '#F0F0FD',
  infoAlertBg: '#e7f1fa',
  ok: '#00B607',
  okBg: '#D9F4DA',
  warn: '#F27400',
  warnBg: '#FDEAD9',
  warnAlertBg: '#fbf2ea',
  errorAlertBg: '#fdeced',
  inactive: '#8A8E99',
  danger: '#FF7070',
  successAlertBg: '#edf7ed',
  textPrimary: '#101828',
  text600: '#A3A3A3',
  text800: '#404040',
  text900: '#000000',
  primaryLight200: '#FCFCFF',
  primaryLight800: '#F3F3FD',
  primaryDark400: '#8F94A1',
  primaryDark600: '#676D7D',
  primaryDark800: '#3E4559',
  primaryMain400: '#AFB1EC',
  primaryMain900: '#6367EF',
  primaryContrast: '#FFFFFF',
  secondaryMain: '#344054',
  secondary200: '#E3E5EE',
  secondary400: '#999DA9',
  secondary900: '#2C3548',
  warning200: '#FFF1DE',
  warning900: '#FFB340',
  neutral300: '#D0D5DD',
  error100: '#DA0000',
  neutral40: '#E4E4E4',
  primary80: '##5F1ECC',
} as const;
export type Color = keyof typeof colors;
